import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import { request } from '../../../functions/apiRequestHelper';
// import { gtmPush } from '../../../functions/gtm';
import DealerByPostcodeModule from '../../../components/DealerByPostcodeModule';
import Button from '../../../audi-ui-components/Button';
import Spinner from '../../../audi-ui-components/Spinner';
import Modal from '../../../audi-ui-components/Modal';

const ApplyFormModal = ({ isActive, close, variant, engine, prices, responseSummary, loantype, gfv, disclaimer, description, locState, theme }) => {
  
  const [applyUrl, setApplyUrl] = useState(false);
  const [error, setError] = useState(false);
  
  const submitForm = (values, formikBag) => {
    // console.log("submitForm", values);
    if (!values.dealer) { return; }
    setError(false);
    let selectedDealer = values.dealer;
    let interestRate = responseSummary.ComparisonRate ? responseSummary.ComparisonRate.value : responseSummary.AnnualRate.value;
    let payload = {
        vehicleData: {
            purchasePriceAmount: parseFloat(responseSummary.DriveawayPrice.value.replace(/[^0-9.-]+/g,"")),
            model: {
                vehicleImageUrl: prices.ImagePath,
                description: `${variant.label} ${engine.label}`,
                colorExterior: "White",
                colorInterior: "Black"
            }
        },
        financialProduct: {
            calculation: {
                duration: parseInt(responseSummary.Term.value),
                effectiveInterestRate: interestRate / 100,
                downPaymentAmount: parseFloat(responseSummary.DownPayment.value.replace(/[^0-9.-]+/g,"")),
                subsequentInstallmentAmount: {amount: parseFloat(responseSummary.Rate.value.replace(/[^0-9.-]+/g,""))},
                loanType: loantype
            },
            detailedName: "CONSUMER_LOAN",
            disclaimer: btoa(unescape(encodeURIComponent(description + "\r\n" + disclaimer)))
        },
        transaction: {localTransactionId: "1"},
        deletionPolicy: {deletionAfterDays: 5},
        dealerData: {
          companyId: selectedDealer.dealer?.dealerCode,
          contactData: {
            companyName: selectedDealer.dealer?.name,
            email: selectedDealer.dealer?.email,
            telephoneCountryCode: "+61",
            telephoneNumber: selectedDealer.dealer?.phone?.replace(/[^0-9]+/g, '')
          },
          address: {
            street: selectedDealer.address,
            houseNumber: "",
            zipCode: selectedDealer.postcode,
            city: selectedDealer.suburb,
            countryCode: "AU",
            state: selectedDealer.state,
          }
        }
    };
    if (responseSummary.BalloonAmount) {
        payload.financialProduct.calculation.balloonPayment = parseFloat(responseSummary.BalloonAmount.value.replace(/[^0-9.-]+/g,""));
    }
    if (responseSummary.GuaranteedFutureValue) {
        payload.financialProduct.calculation.guaranteedBuyBackPrice = parseFloat(responseSummary.GuaranteedFutureValue.value.replace(/[^0-9.-]+/g,""));
    }
    if (loantype === "ChattelMortgage") { payload.financialProduct.detailedName = "CHATTEL_MORTGAGE"; }
    if (gfv === "AudiChoice") {
      payload.financialProduct.detailedName += "_CHOICE";
      payload.financialProduct.calculation.yearlyMileage = responseSummary.KMLimit ? parseInt(responseSummary.KMLimit.value) : 0;
    }
    // console.log(payload);
    request(`${process.env.RAZZLE_API_HOST}/1/afs/onlineapplication`, {
        method: "POST",
        body: JSON.stringify(payload)
    }).then(response => {
        // console.log(response);
        formikBag.setSubmitting(false);
        let url = `${process.env.RAZZLE_AFS_APPLY}?cid=${response}`;
        var win = window.open(url, '_blank');
        if (win) {
            win.focus();
            close();
        } else {
            //Browser has blocked it
            setApplyUrl(url);
        }
    }).catch(error => {
        setError(true);
        formikBag.setSubmitting(false);
    });
  }
  
  const onClose = () => {
    setApplyUrl(false);
    setError(false);
    close();
  }
  
  return (
    <Modal isActive={isActive} modalStyle="layer" closeButton close={onClose}>
      
      {applyUrl && <p className="py-5">We couldn't automatically redirect you. Please <a href={applyUrl} target="_blank" className="aui-textlink">click here</a> for your online finance application.</p>}
      
      {!applyUrl && isActive && <Formik onSubmit={submitForm} initialValues={{variantId: variant.id}}>
        {(formikBag) => (
          <Form className="audi-form">
            {formikBag.isSubmitting && <div className="spinner-wrapper"><Spinner isContinuous /></div>}
            <p className="aui-headline-3 mb-5">Please select your Audi Dealer</p>
            <DealerByPostcodeModule
              title="Find your preferred or nearest Audi dealer by postcode"
              additionalDealerFields="email phone"
              additionalLocationFields="address"
              theme={theme}
              {...formikBag}
            />
            <p className="my-3">The Audi Repayment calculator is only an indication. Your selected Audi Dealer will give you a tailored Audi repayment depending on your circumstances.</p>
            {error && <p className="py-2 aui-color-text-red">An error has occured</p>}
            <p className="text-right my-3">
              <Button label="Select" type="submit" buttonType="primary" disabled={!formikBag.values.dealerId} theme={theme === "dark" ? "light" : null} />
            </p>
          </Form>
        )}
      </Formik>}
    
    </Modal>
  );
}

export default ApplyFormModal;
